import { FunctionComponent, SVGAttributes } from 'react';
import { Address } from 'viem';

import MezIcon from '@/app/assets/token/mez.svg?react';
import UsdcIcon from '@/app/assets/token/UsdcIcon';
import {
  HASTRA_JUNIOR_TRANCHE,
  HASTRA_MZUSD,
  HASTRA_SENIOR_TRANCHE,
  JUNIOR_TRANCHE,
  MZUSD,
  SENIOR_TRANCHE,
  USDC,
} from '@/app/shared/constants/web3/constants';

export type Token = {
  address: Address;
  symbol: string;
  decimals: number;
  Icon: FunctionComponent<SVGAttributes<SVGElement>>;
  isNative?: boolean;
  isWrap?: boolean;
};

export const TOKENS = {
  [USDC]: {
    address: USDC,
    symbol: 'USDC',
    decimals: 6,
    Icon: UsdcIcon,
  },
  [MZUSD]: {
    address: MZUSD,
    symbol: 'mzUSD',
    decimals: 18,
    Icon: MezIcon,
  },
  [HASTRA_MZUSD]: {
    address: HASTRA_MZUSD,
    symbol: 'mzUSD',
    decimals: 18,
    Icon: MezIcon,
  },
  [SENIOR_TRANCHE]: {
    address: SENIOR_TRANCHE,
    symbol: 'msPRIME',
    decimals: 21,
    Icon: MezIcon,
  },
  [JUNIOR_TRANCHE]: {
    address: JUNIOR_TRANCHE,
    symbol: 'mjPRIME',
    decimals: 21,
    Icon: MezIcon,
  },
  [HASTRA_SENIOR_TRANCHE]: {
    address: HASTRA_SENIOR_TRANCHE,
    symbol: 'msHastra',
    decimals: 21,
    Icon: MezIcon,
  },
  [HASTRA_JUNIOR_TRANCHE]: {
    address: HASTRA_JUNIOR_TRANCHE,
    symbol: 'mjHastra',
    decimals: 21,
    Icon: MezIcon,
  },
} as const satisfies Record<Address, Token>;

export const TOKENS_ADDRESS_ARR = Object.keys(TOKENS) as Address[];
export const TOKENS_ARR: Token[] = Object.values(TOKENS);

export type TokenSymbol = (typeof TOKENS)[keyof typeof TOKENS]['symbol'];

export const TOKENS_BY_SYMBOL = Object.values(TOKENS).reduce(
  (acc, token) => {
    acc[token.symbol] = token;
    return acc;
  },
  {} as Record<TokenSymbol, Token>,
);
